import { type PlayerTeam } from '../game/core/player.ts';

export const GAME_ID_LENGTH = 6;

const gameIdPattern = /^[ABCDEFGHJKMNPQRSTUVWXYZ0123456789]{6}$/;
const gameIdCharset = 'ABCDEFGHJKMNPQRSTUVWXYZ0123456789';

export function isValidGameId(gameId: string): boolean {
    return gameIdPattern.test(gameId);
}

export function generateUniqueId(length = GAME_ID_LENGTH) {
    let result = '';
    const randomValues = new Uint8Array(length);

    globalThis.crypto.getRandomValues(randomValues);

    for (let i = 0; i < length; i++) {
        result += gameIdCharset[randomValues[i]! % gameIdCharset.length];
    }

    return result;
}

export function randomName(): string {
    const randomNames = ['Alice', 'Bob', 'Charlie', 'David', 'Eve', 'Frank', 'Grace', 'Heidi', 'Ivan', 'Judy', 'Mallory', 'Oscar', 'Peggy', 'Trent', 'Walter'];
    return randomNames[Math.floor(Math.random() * randomNames.length)]!;
}

export function randomUnusedTeam(teams: string[]): PlayerTeam | undefined {
    const teamNames = ['red', 'blue', 'green', 'yellow', 'orange', 'purple', 'pink', 'black', 'white', 'gray'];

    while (teamNames.length) {
        const randomIndex = Math.floor(Math.random() * teamNames.length);
        const team = teamNames[randomIndex];
        if (team && !teams.includes(team)) {
            return team as PlayerTeam;
        }
        teamNames.splice(randomIndex, 1);
    }
}

export function filterUndefinedKeys<T>(obj: Record<string, T | undefined>): Record<string, T> {
    return Object.entries(obj).reduce((result, [key, value]) => {
        if (value) {
            result[key] = value;
        }
        return result;
    }, {} as Record<string, T>);
}

export function serializePosition(p: { x: number, y: number }) {
    return `${p.x},${p.y}`;
}

export function deserializePosition(position?: string): [number, number] {
    if (position) {
        const [x, y] = position.split(',').map(Number);
        return [x!, y!];
    }

    return [-1, -1];
}

export function getTeamColor(team: PlayerTeam) {
    switch (team) {
        case 'red':
            return '#ef4444';
        case 'blue':
            return '#3b82f6';
        case 'green':
            return '#22c55e';
        case 'yellow':
            return '#eab308';
        case 'orange':
            return '#f97316';
        case 'purple':
            return '#a855f7';
        case 'pink':
            return '#ec4899';
        case 'black':
            return '#000000';
        case 'white':
            return '#ffffff';
        case 'gray':
            return '#6b7280';
    }
}
